export const iconFontAwesomeUsersPeopleUsersRays = (
	<i className="fa-solid fa-users-rays"></i>
);
